<template>
  <div aria-label="datetime range dropdown" class="btn-group btn-group-sm" role="group">
    <div id="vueDialBack">
      <dial-back-input
          v-if="dateRange"
          @media-button-pressed="mediaButtonHandler"
          :date-range-handler="dateRangeHandler"
          :is-back-disabled="!isMoveRangeBackwardEnabled"
          :is-forward-disabled="!isMoveRangeForwardEnabled"
          :is-live="isLive"
          :is-paused="!isLive"
          :date-range="dateRange"
          :dial-back-hours="DIAL_BACK_HOURS"
          :show-downsampling="showDownsampling"
      />
    </div>
</div>

</template>
<script>
import DialBackInput from '../../components/dialBackInput/dialBackInput.vue';
import DateRangeModel from '../../components/dialBackInput/date-range-picker.model';
import DateRangeHelperService from '../../components/dialBackInput/date-range-picker.helper-service';
import LoginService from '../../services/login.service';

/**
 * New date rang picker for Monitoring but leaving old picker for analytics.
 */

const PLAY_BUTTON_TYPE = 'play';
const PAUSE_BUTTON_TYPE = 'pause';
const BACK_BUTTON_TYPE = 'back';
const FORWARD_BUTTON_TYPE = 'forward';
const INTERVAL_BETWEEN_UPDATES_IN_MS = 60 * 1000;  // 1 minute - 'production' value

const DEFAULT_LABEL = 'Last Hour';

export default {
  name: 'DialBackComponent',
  props: {
    dateRangeModel: {
      type: Object,
      required: true,
    },
    showDownsampling: {
      type: Boolean,
      default: false
    },
  },
  data: function() {
    const DIAL_BACK_HOURS = LoginService.userObject.cpmmDialBackHours;
    let dateRangeHelperService = new DateRangeHelperService(DIAL_BACK_HOURS);
    return {
      currentDateRangeModel: this.dateRangeModel,
      dateRangeHelperService: dateRangeHelperService,
      DIAL_BACK_HOURS: DIAL_BACK_HOURS,
      DIRECTION_BACKWARD: dateRangeHelperService.MOVE_DIRECTION.BACKWARD,
      DIRECTION_FORWARD: dateRangeHelperService.MOVE_DIRECTION.FORWARD,
    };
  },
  components: {
    DialBackInput
  },
  watch: {
    dateRangeModel: {
      deep: true,
      handler(newDateRange, oldDateRange) {
        if (newDateRange.startDate && newDateRange.endDate) {
          this.currentDateRangeModel = newDateRange;
        }
      }
    }
  },

  computed: {
    dateRange: function() {
      return this.currentDateRangeModel.getCurrentRange()
    },
    isLive: function() { 
      return this.currentDateRangeModel.getLiveModeStatus(); 
    },
    statusModeLegendStyle: function () {
        return this.dateRangeModel.getLiveModeStatus() ? 'live-mode-on-legend' : 'live-mode-off-legend';
    },
    statusModeLegendText: function () {
        return 'LIVE: ' + (this.currentDateRangeModel.getLiveModeStatus() ? 'ON' : 'OFF');
    },
    isMoveRangeBackwardEnabled: function() { return this.isTimeRangeEnabled(this.DIRECTION_BACKWARD) },
    isMoveRangeForwardEnabled: function() { return this.isTimeRangeEnabled(this.DIRECTION_FORWARD) },

  },
  methods: {
    setCurrentRange: function(range) {
      this.currentDateRangeModel.setCurrentRange(range);
      this.$emit('dial-back-current-range', range);
    },
    updateLiveTimes: function() {
        var self = this;
        var isLiveMode = self.currentDateRangeModel.getLiveModeStatus();
        var currentRange = self.currentDateRangeModel.getCurrentRange();

        if (isLiveMode) {
            var newRange = getClosestRange(currentRange);
            var newLabel = self.dateRangeHelperService.getFormattedDuration(newRange, isLiveMode);
            self.setCurrentRange({
                startDate: newRange.startDate,
                endDate: newRange.endDate,
                rangeLabel: newLabel
            });
        }
    },
    mediaButtonHandler: function(buttonType) {
      switch (buttonType) {
          case PLAY_BUTTON_TYPE:
              this.toggleLiveMode();
              break;
          case PAUSE_BUTTON_TYPE:
              this.toggleLiveMode();
              break;
          case BACK_BUTTON_TYPE:
              this.moveRangeBackward();
              break;
          case FORWARD_BUTTON_TYPE:
              this.moveRangeForward();
              break;
          default:
              console.warn('unrecognized button type', buttonType);
              break;
      }
    },
    dateRangeHandler(newDateRange) {
      let isLive = this.currentDateRangeModel.getLiveModeStatus();
      if (newDateRange.isLive && !isLive || !newDateRange.isLive && isLive) {
        this.toggleLiveMode();
      }
      this.setCurrentRange(newDateRange);
    },

    isTimeRangeEnabled: function (direction) {
        var self = this;
        return self.currentDateRangeModel.getLiveModeStatus() ? false : self.dateRangeHelperService.isNextRangeValid(self.currentDateRangeModel.getCurrentRange(), direction);
    },

    moveRangeBackward: function () {
        var self = this;
        if (self.isTimeRangeEnabled(self.dateRangeHelperService.MOVE_DIRECTION.BACKWARD)) {
            var currentRange = self.currentDateRangeModel.getCurrentRange();
            var updatedRange =
                self.dateRangeHelperService.moveTimeRange(currentRange, self.dateRangeHelperService.MOVE_DIRECTION.BACKWARD);
            self.setCurrentRange(updatedRange);

            var isLiveMode = self.currentDateRangeModel.getLiveModeStatus();
            if (isLiveMode) {
                self.currentDateRangeModel.setLiveModeStatus(false);
            }
        }
    },

    moveRangeForward: function () {
        var self = this;
        if (self.isTimeRangeEnabled(self.dateRangeHelperService.MOVE_DIRECTION.FORWARD)) {
            var currentRange = self.currentDateRangeModel.getCurrentRange();
            var updatedRange =
                self.dateRangeHelperService.moveTimeRange(currentRange, self.dateRangeHelperService.MOVE_DIRECTION.FORWARD);
            self.setCurrentRange(updatedRange);

            var isLiveMode = self.currentDateRangeModel.getLiveModeStatus();
            if (isLiveMode) {
                self.currentDateRangeModel.setLiveModeStatus(false);
            }
        }
    },

    toggleLiveMode: function () {
        var self = this;
        var newLiveMode = !self.currentDateRangeModel.getLiveModeStatus();
        self.currentDateRangeModel.setLiveModeStatus(newLiveMode);

        var currentRange = self.currentDateRangeModel.getCurrentRange();
        var isKnownRange = self.dateRangeHelperService.isValidRangeLabel(currentRange.rangeLabel);

        if (isKnownRange) {
            var duration = self.dateRangeHelperService.getDurationFromRange(currentRange);
            var newRange = self.dateRangeHelperService.getRangeFromNowByDuration(duration);
            self.setCurrentRange({
                startDate: newRange.startDate,
                endDate: newRange.endDate,
                rangeLabel: currentRange.rangeLabel
            });
        } else if (newLiveMode) {
            var newRange = getClosestRange(currentRange);
            var newLabel = self.dateRangeHelperService.getFormattedDuration(newRange, newLiveMode);
            self.setCurrentRange({
                startDate: newRange.startDate,
                endDate: newRange.endDate,
                rangeLabel: newLabel
            });
        }
    },
  },
  mounted: function() {
    var self = this;

    self.currentDateRangeModel.setAvailableRanges(self.dateRangeHelperService.getDefaultRanges());

    //  Updates 'start' and 'end' date-times each 'INTERVAL_BETWEEN_UPDATES_IN_MS' if live mode is enabled
    self.timerObservable = Rx.Observable
        .timer(INTERVAL_BETWEEN_UPDATES_IN_MS, INTERVAL_BETWEEN_UPDATES_IN_MS)
        .subscribe(function () {
            if (self.currentDateRangeModel.getLiveModeStatus()) {
                self.updateLiveTimes();
            }
        });
  },
  beforeDestroy: function() {
    var self = this;
    self.timerObservable.dispose()
  }
}

/**
 * Function to get the closest live range so this will return the closest range
 * we support shifted to the current time.
 */
 function getClosestRange(dateRange, dialBackHours) {
  let endDate = dateRange.endDate;
  let rangeInHours = moment.duration(dateRange.endDate.diff(dateRange.startDate)).asHours();
  if (rangeInHours >= 720) {
    return {
      startDate: moment().subtract(720, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 240) {
    return {
      startDate: moment().subtract(240, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 120) {
    return {
      startDate: moment().subtract(120, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 24) {
    return {
      startDate: moment().subtract(24, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 4) {
    return {
      startDate: moment().subtract(4, 'hours'),
      endDate: moment()
    };
  }
  if (rangeInHours >= 1) {
    return {
      startDate: moment().subtract(1, 'hours'),
      endDate: moment()
    };
  }
  return {
    startDate: moment(),
    endDate: moment()
  };
}
</script>
<style lang="scss" scoped>
</style>